import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]


export default /*#__PURE__*/_defineComponent({
  __name: 'button4',
  props: {
  id: {
    type: String,
    required: false,
    default: "",
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    id: __props.id,
    class: "tw-h-[fit-content] tw-flex tw-items-start tw-gap-2.5 tw-px-5 tw-py-2 tw-rounded-[100px] tw-border-[1.5px] tw-border-solid tw-border-[#EFF0F1] tw-bg-[#FFFFFF] tw-no-underline tw-cursor-pointer tw-text-[#387DFF] tw-text-center tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[normal]"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}
}

})